import phoenixLogo from "../../assets/phoenix.png";
import phoenixColorBands from "../../assets/color_bands copie 2.png";
import './style.css';

function Inscriptions() {
    return (
        <>
            <div id="inscriptions">
                {/*<section id="phoenixLogo"><img src={phoenixLogo} alt=""/></section>
              <section id="phoenixColorBands"><img src={phoenixColorBands} alt=""/></section>*/}
                <div id="invitation-container">
                    <h1>CONTACT</h1>
                    <br/>
                    <br/>
                    <p>Pour toute question, vous pouvez nous écrire à l'adresse suivante :</p>
                    <br/>
                    <br/>
                    <p><strong>Mail :</strong> phoenix1211.groupe@gmail.com</p>
                    <br/>
                    <br/>
                    <p><strong>Organisatrices :</strong></p>
                    <p>Aurélie Lebbe, Caroline de Brouwer, Charlotte de le Vingne, Maroussia de Behault et Wivine de Caritat de Peruzzis</p>
                    <br/>
                    <div id="link-button">
                        <a
                            href="mailto:phoenix1211.groupe@gmail.com"
                            target="_blank">NOUS CONTACTER</a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Inscriptions;